import { render, staticRenderFns } from "./modulos-eod.vue?vue&type=template&id=44bb2224&scoped=true"
import script from "./modulos-eod.vue?vue&type=script&lang=js"
export * from "./modulos-eod.vue?vue&type=script&lang=js"
import style0 from "./modulos-eod.vue?vue&type=style&index=0&id=44bb2224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bb2224",
  null
  
)

export default component.exports